import moment from "moment";
import { useMemo, useRef, useState } from "react";
import { mostraAlertaError, mostraAlertaOk,mostraAlertaPersonalizada } from "../../../../componentes/alerts/sweetAlert";
import { AxiosPrivado } from "../../../../componentes/axios/Axios";
import Card from "../../../../componentes/contenedores/Card";
import ModalBootstrap from "../../../../componentes/modal/ModalBootstrap";
import Page from "../../../../componentes/plantilla/Page";
import Tablas from "../../../../componentes/tablas/TablasGenerico";
import TablasClientes from "../../../../componentes/tablas/TablasEmpleados";
import { InventariosAnulado, InventariosListar, ProductosListar } from "../../../../configuracion/apiUrls";
import { useContextEmpleado } from "../../../../contexto/empleado/EmpleadoContext";
import { useContextUsuario } from "../../../../contexto/usuario/UsuarioContext";
import { ImprimirInventario } from "./ImprimirInventarios";
import {GenerarReporteInventarioPDF}  from "./ReporteInventarios";
import { formatoFecha, formatoMoneda } from '../../../../configuracion/validaciones';

const HomeAnularInventarios = () => {
    const { listaInventarios, ActualizarLista, setListaInventarios, setListaProductos } = useContextEmpleado();
    const { usuario } = useContextUsuario();
    const [modalOpen, setModalOpen] = useState(false);
    const [descripcionAnulacion, setDescripcionAnulacion] = useState("");
    const refEdicion = useRef(null);
    const [inventarioSeleccionado, setInventarioSeleccionado] = useState(null);
    const [estadoFiltro, setEstadoFiltro] = useState("Activo");
    const [fechaFiltro, setFechaFiltro] = useState(formatoFecha(new Date()));
    const [panelAbierto, setPanelAbierto] = useState(false);

    const datos = {
        titulo: {
            titulo: "Gestion de inventarios",
            url: "/app/admin/inventarios/gestion",
            tituloUrl: "Menu gestion",
            nombreUrl: "Inicio",
        },
    };

    const estadosInventario = [
        { value: "Activo", label: "Activo" },
        { value: "Anulada", label: "Anulada" },
        { value: "Todos", label: "Todos" },
    ];

    const handleSeleccionarInventario = (inventario) => {
        setInventarioSeleccionado(inventario);
        setTimeout(() => {
            if (refEdicion.current) {
                refEdicion.current.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                });
            }
        }, 100);
    };

    const handleImprimir = (inventario) => {
        mostraAlertaPersonalizada({
            titulo: "¿Qué tipo de impresión desea?",
            mensaje: "Seleccione el formato del documento.",
            icono: "question",
            textoConfirmacion: "Reporte PDF (A4)",
            textoCancelacion: "Comprobante (Ticket)",
            accion: (esReportePDF) => {
                // Segunda pregunta: Nivel de detalle
                mostraAlertaPersonalizada({
                    titulo: "Nivel de Detalle",
                    mensaje: "¿Desea ver el desglose por lotes o el total por producto?",
                    icono: "info",
                    textoConfirmacion: "Solo Producto",
                    textoCancelacion: "Detallado (Lotes)",
                    accion: (soloProducto) => {
                        if (esReportePDF) {
                            GenerarReporteInventarioPDF(inventario, soloProducto);
                        } else {
                            ImprimirInventario(inventario, soloProducto);
                        }
                    },
                    foco: true
                });
            },
            foco: true
        });
    };

    const confirmarAnulacion = async () => {
        if (!descripcionAnulacion.trim()) {
            return mostraAlertaError("Debe ingresar una descripción para la anulación.", "Error");
        }
        const listaOrdenada = [...listaInventarios].sort((a, b) => new Date(a.fecha) - new Date(b.fecha));
        const indexActual = listaOrdenada.findIndex(i => i.id === inventarioSeleccionado.id);
        if (indexActual > 0) {
            const penultimo = listaOrdenada[indexActual - 1];
            if (penultimo.estado === "Anulada") {
                return mostraAlertaError(`No se puede anular el inventario #${inventarioSeleccionado.id} porque el inventario anterior (#${penultimo.id}) ya está anulado.`, "Acción no permitida");
            }
        }
        try {
            await AxiosPrivado.post(InventariosAnulado, {
                inventarioId: inventarioSeleccionado.id,
                fechaHora: moment().format("YYYY-MM-DDTHH:mm:ssZ"),
                estado: "Anulada",
                empleadoId: usuario.datoPersonales.id,
                descripcion: descripcionAnulacion,
            });
            mostraAlertaOk("Inventario anulado correctamente.", "Éxito");
            ActualizarLista(InventariosListar, setListaInventarios);
            ActualizarLista(ProductosListar, setListaProductos);
            setModalOpen(false);
            setDescripcionAnulacion("");
            setInventarioSeleccionado(null);
            setTimeout(() => {
                window.scrollTo({ top: 0, behavior: "smooth" });
            }, 100);
        } catch (er) {
            const msjError =
                er?.response?.data?.msj ||
                er?.response?.data?.error?.message ||
                "Ocurrió un error desconocido.";
            mostraAlertaError(msjError, "Error");
        }
    };

    const handleFiltrar = () => {
        setPanelAbierto(false);
    };

    const handleReset = () => {
        setEstadoFiltro("Todos");
        setFechaFiltro("");
        setPanelAbierto(false);
    };

    const inventariosFiltrados = useMemo(() => {
        return listaInventarios.filter(inventario => {
            let pasaFiltro = true;

            const estadoInventario = inventario.estado;
            if (estadoFiltro === "Activo") {
                pasaFiltro = pasaFiltro && (estadoInventario !== "Anulada");
            } else if (estadoFiltro === "Anulada") {
                pasaFiltro = pasaFiltro && (estadoInventario === "Anulada");
            }

            if (fechaFiltro) {
                const fechaDeseada = fechaFiltro.trim();
                const inventarioDateFormato = inventario.fecha ? formatoFecha(inventario.fecha) : null;

                pasaFiltro = pasaFiltro && (inventarioDateFormato === fechaDeseada);
            }

            return pasaFiltro;
        });
    }, [listaInventarios, estadoFiltro, fechaFiltro]);

    const renderFilterPanel = () => (
        <div className="mb-4 d-flex justify-content-end">
            <div className="position-relative">
                <button
                    className={`btn ${panelAbierto ? "btn-danger" : "btn-primary"} d-flex justify-content-between align-items-center`}
                    onClick={() => setPanelAbierto(!panelAbierto)}
                    style={{
                        borderRadius: "6px",
                        padding: "6px 12px",
                        fontSize: "0.9rem",
                        minWidth: "140px",
                    }}
                >
                    <span className="d-flex align-items-center">
                        <i className="fas fa-filter mx-2"></i>
                        Filtros
                    </span>
                    <i className={`fas fa-chevron-${panelAbierto ? "up" : "down"}`}></i>
                </button>

                {panelAbierto && (
                    <div
                        className="position-absolute top-100 mt-2 bg-body border border-secondary-subtle text-body shadow"
                        style={{
                            minWidth: "280px",
                            right: 0,
                            borderRadius: "10px",
                            backgroundColor: "#fff",
                            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                            padding: "15px",
                            zIndex: 1050,
                        }}
                    >
                        <div className="form-group mb-3">
                            <label htmlFor="filtroEstadoSelect" className="form-label fw-bold">Estado del Inventario</label>
                            <select
                                id="filtroEstadoSelect"
                                className="form-control form-control-sm"
                                value={estadoFiltro}
                                onChange={(e) => setEstadoFiltro(e.target.value)}
                            >
                                {estadosInventario.map((estado) => (
                                    <option key={estado.value} value={estado.value}>
                                        {estado.label}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="form-group mb-3">
                            <label htmlFor="fechaFiltroInput" className="form-label fw-bold">Fecha del Inventario</label>
                            <input
                                id="fechaFiltroInput"
                                type="date"
                                className="form-control form-control-sm"
                                value={fechaFiltro}
                                onChange={(e) => setFechaFiltro(e.target.value)}
                            />
                        </div>

                        <div className="d-flex justify-content-end">
                            <button className="btn btn-sm btn-primary mx-2" onClick={handleFiltrar}>
                                <i className="fas fa-filter mx-1"></i> Filtrar
                            </button>
                            <button className="btn btn-sm btn-secondary" onClick={handleReset}>
                                <i className="fas fa-sync-alt mx-1"></i> Reiniciar
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );

    const columnasTabla = useMemo(() => [
        {
            title: "ID",
            data: "id",
        },
        {
            title: "Fecha",
            data: "fecha",
            render: (fecha) => {
                const f = moment(fecha);
                return f.isValid() ? f.format("DD/MM/YYYY") : "N/A";
            }
        },
        {
            title: "Empleado",
            data: "Usuario.Empleados",
            render: (empleados) => {
                const empleado = empleados?.[0];
                return empleado?.nombreCompleto || "Sin empleado";
            }
        },
        {
            title: "Total Sobrante",
            data: "totalSobrante",
            render: (data) => {
                const valor = parseFloat(data || 0);
                const clase = valor >= 0 ? "text-success" : "text-danger";
                return `<span class="${clase}">${formatoMoneda(valor)}</span>`;
            }
        },
        {
            title: "Total Faltante",
            data: "totalFaltante",
            render: (data) => {
                const valor = parseFloat(data || 0);
                const clase = valor >= 0 ? "text-success" : "text-danger";
                return `<span class="${clase}">${formatoMoneda(valor)}</span>`;
            }
        },
        {
            title: "Total Cierre",
            data: "totalCierre",
            render: (data) => {
                const valor = parseFloat(data || 0);
                const clase = valor >= 0 ? "text-success" : "text-danger";
                return `<span class="${clase}">${formatoMoneda(valor)}</span>`;
            }
        },
        {
            title: "Estado",
            data: "estado",
            render: (estado) => {
                const clase = estado === "Anulada" ? "badge bg-danger" : "badge bg-success";
                const estadoMostrar = estado === "Anulada" ? "Anulada" : "Activo";
                return `<span class="${clase}">${estadoMostrar}</span>`;
            }
        },
        {
            title: "Acciones",
            data: null,
            orderable: false,
            actions: [
                {
                    key: "ver",
                    className: "btn btn-outline-primary btn-sm",
                    icon: "fas fa-eye",
                    title: "Ver Detalles",
                    onClick: (rowData) => handleSeleccionarInventario(rowData)
                },
                {
                    key: "imprimir",
                    className: "btn btn-outline-secondary btn-sm",
                    icon: "fas fa-print",
                    title: "Imprimir",
                    onClick: (rowData) => handleImprimir(rowData)
                }
            ]
        }
    ], []);

    const columnasDetalle = useMemo(() => [
        {
            title: "Producto / Lote / Inventario",
            data: null,
            render: (data) => {
                const productoNombre = data.producto?.nombre || "N/A";
                const loteNombre = data.lote?.nombre_lote || "N/A";
                const loteInventarioNombre = data.loteinventario?.inventarioTipo?.nombre || "N/A";
                return `
                    <strong>Producto:</strong> ${productoNombre}<br/>
                    <strong>Lote:</strong> ${loteNombre}<br/>
                    <strong>Inv. Lote:</strong> ${loteInventarioNombre}
                `;
            }
        },
        { title: "Existencia Sistema", data: "existenciaSistema" },
        { title: "Existencia Actual", data: "existenciaActual" },
        {
            title: "Balance",
            data: "balance",
            render: (data) => {
                const valor = parseFloat(data);
                const clase = valor > 0 ? "text-success" : valor < 0 ? "text-danger" : "";
                return `<span class="${clase}">${valor > 0 ? "+" : ""}${valor}</span>`;
            }
        },
        {
            title: "Cierre",
            data: "cierre",
            render: (data) => formatoMoneda(data)
        },
    ], [formatoMoneda]);

    return (
        <Page datos={datos}>
            <Card>
                {renderFilterPanel()}
                <Tablas
                    id="tablaAnularInventarios"
                    datos={inventariosFiltrados}
                    columnas={columnasTabla}
                />
            </Card>
            {inventarioSeleccionado && (
                <div ref={refEdicion} className="mt-4">
                    <Card
                        titulo={`Detalle de inventario #${inventarioSeleccionado.id}`}
                        className="p-4 shadow-lg rounded"
                        pie={
                            <ModalBootstrap
                                titulo={`Anular Inventario #${inventarioSeleccionado.id}`}
                                modalIsOpen={modalOpen}
                                setModalIsOpen={setModalOpen}
                                nombreBoton="Anular inventario"
                                estiloBoton="btn btn-danger"
                                iconBoton="fas fa-ban"
                                pie={
                                    <>
                                        <button
                                            className="btn btn-success"
                                            onClick={confirmarAnulacion}
                                        >
                                            Confirmar
                                        </button>
                                    </>
                                }
                            >
                                {inventarioSeleccionado.inventarioanuladas &&
                                    inventarioSeleccionado.inventarioanuladas.length > 0 ? (
                                    <div className="text-center">
                                        <p>Este inventario ya ha sido anulado.</p>
                                    </div>
                                ) : (
                                    <>
                                        <div className="mb-3">
                                            <label className="form-label fw-bold">
                                                Motivo de anulación
                                            </label>
                                            <textarea
                                                className="form-control"
                                                rows="3"
                                                value={descripcionAnulacion}
                                                onChange={(e) => setDescripcionAnulacion(e.target.value)}
                                            />
                                        </div>
                                    </>
                                )}
                            </ModalBootstrap>
                        }
                    >
                        {inventarioSeleccionado.notas && (
                            <div className="alert alert-info mb-4">
                                <h6 className="fw-bold"><i className="fas fa-info-circle me-2"></i> Notas del Inventario:</h6>
                                <p className="mb-0">{inventarioSeleccionado.notas}</p>
                            </div>
                        )}
                        <TablasClientes
                            id="tablaDetalleInventario"
                            datos={inventarioSeleccionado.inventarioDetalles || []}
                            columnas={columnasDetalle}
                        />
                    </Card>
                </div>
            )}
        </Page>
    );
};

export default HomeAnularInventarios;